import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/upload.svg'
import _imports_1 from '@/assets/images/step1.svg'
import _imports_2 from '@/assets/images/rv/complete.svg'


const _withScopeId = n => (_pushScopeId("data-v-9156e174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uploadCon" }
const _hoisted_2 = { class: "licenseUploadCon" }
const _hoisted_3 = {
  key: 0,
  class: "uploadH"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "uploadIcon"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, [
  /*#__PURE__*/_createTextVNode(" 拖拽车辆核查结果文件到此处或"),
  /*#__PURE__*/_createElementVNode("span", { class: "blueFont" }, "点击浏览文件")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "uploadH uploadProgressCon"
}
const _hoisted_7 = { class: "progressCon" }
const _hoisted_8 = { class: "progressFlexCon" }
const _hoisted_9 = { class: "totalProgressCon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "batchIcon"
}, null, -1))
const _hoisted_11 = { class: "progressShow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progressTit" }, "Upload：", -1))
const _hoisted_13 = { class: "filePro uploadPro" }
const _hoisted_14 = {
  key: 0,
  class: "completeCon"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "completeIcon"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "filePro fileSize" }
const _hoisted_20 = {
  key: 0,
  class: "resultCon"
}
const _hoisted_21 = {
  class: "result",
  ref: "result"
}
const _hoisted_22 = {
  key: 0,
  class: "bottom"
}
const _hoisted_23 = { class: "closeBtnCon" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "Upload Checking Result",
    closable: true,
    visible: _ctx.modal,
    width: "35.14%",
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.uploadComplete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_a_upload_dragger, {
                  name: "file",
                  multiple: true,
                  action: "",
                  listType: "picture-card",
                  showUploadList: false,
                  customRequest: _ctx.uploadCustomRequest,
                  "before-upload": _ctx.beforeUpload
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["customRequest", "before-upload"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.uploadComplete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_a_progress, {
                        percent: _ctx.uploadPercent,
                        status: _ctx.uploadProStatus
                      }, null, 8, ["percent", "status"]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.uploadPercent == 100)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.uploadContent), 1))
                      ]),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.uploadFileSize), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isContinue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_a_table, {
                rowKey: 
            (record, index) => {
              return record.vinNo + index.toString();
            }
          ,
                scroll: { y: _ctx.tableHeight },
                columns: _ctx.columns,
                pagination: false,
                dataSource: _ctx.tableData
              }, {
                result: _withCtx(({ text }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass({ error: text.indexOf('失败') > -1 })
                  }, _toDisplayString(text), 3)
                ]),
                _: 1
              }, 8, ["rowKey", "scroll", "columns", "dataSource"])
            ], 512),
            (_ctx.tableData && _ctx.tableData.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_a_pagination, {
                    total: _ctx.pagination.total,
                    "show-size-changer": "",
                    "show-total": (total) => `共 ${total} 条`,
                    onChange: _ctx.pageChange,
                    onShowSizeChange: _ctx.sizeChange,
                    pageSize: _ctx.pagination.pageSize,
                    "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
                    pageSizeOptions: ['10', '20', '30', '40', '50']
                  }, {
                    buildOptionText: _withCtx((props) => [
                      _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
                    ]),
                    _: 1
                  }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_a_button, {
          type: "primary",
          class: "button",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}